// Minimal, dependency-free SVG pie renderer (no animations).
(function () {
  var COLORS = [
    "#533b59","#ff7aca","#32a791","#eab100","#d53771",
    "#3DBAE5","#5F2EA0","#D91F62","#82BD40","#4A4A4A"
  ];

  function polarToCartesian(cx, cy, r, angleDeg) {
    var rad = (angleDeg - 90) * Math.PI / 180;
    return { x: cx + (r * Math.cos(rad)), y: cy + (r * Math.sin(rad)) };
  }
  function describeWedge(cx, cy, r, startAngle, endAngle) {
    var start = polarToCartesian(cx, cy, r, endAngle);
    var end   = polarToCartesian(cx, cy, r, startAngle);
    var largeArc = (endAngle - startAngle) <= 180 ? 0 : 1;
    return "M " + cx + " " + cy + " L " + start.x + " " + start.y +
           " A " + r + " " + r + " 0 " + largeArc + " 0 " + end.x + " " + end.y + " Z";
  }
  function numberFromText(txt) {
    if (!txt) return 0;
    var cleaned = String(txt).replace(/[^\d.,-]/g, "").replace(/,/g, "");
    var n = parseFloat(cleaned);
    return isNaN(n) ? 0 : n;
  }
  function getLabelFromEm(emEl) {
    var clone = emEl.cloneNode(true);
    var strong = clone.querySelector("strong");
    if (strong && strong.parentNode) strong.parentNode.removeChild(strong);
    return (clone.textContent || "").replace(/\s+/g, " ").trim();
  }
  function buildAriaLabel(labels, values) {
    var parts = [];
    for (var i = 0; i < values.length; i++) {
      var pct = Math.round(values[i] * 10) / 10;
      var label = labels[i] || ("Slice " + (i + 1));
      parts.push(label + ": " + pct + "%");
    }
    return "Pie chart showing " + parts.join(", ") + ".";
  }

  function renderPie(pieEl, legendEl) {
    var liNodes = legendEl.querySelectorAll("li");
    var emNodes = legendEl.querySelectorAll("li em");

    var values = [];
    for (var i = 0; i < liNodes.length; i++) {
      values.push(numberFromText(liNodes[i].getAttribute("data-pct")));
    }
    var labels = [];
    for (var j = 0; j < emNodes.length; j++) {
      labels.push(getLabelFromEm(emNodes[j]));
    }

    var sum = 0;
    for (var k = 0; k < values.length; k++) sum += values[k];
    if (sum <= 0) { pieEl.innerHTML = ""; return; }

    var size = 220, r = size / 2, cx = r, cy = r;
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", "0 0 " + size + " " + size);
    svg.setAttribute("width", "100%");
    svg.setAttribute("height", "100%");
    svg.setAttribute("role", "img");
    svg.setAttribute("aria-label", buildAriaLabel(labels, values));
    svg.style.display = "block";

    var angle = 0;
    for (var s = 0; s < values.length; s++) {
      var v = values[s];
      var sliceAngle = (v / sum) * 360;
      if (sliceAngle > 0) {
        var path = document.createElementNS("http://www.w3.org/2000/svg", "path");
        path.setAttribute("d", describeWedge(cx, cy, r, angle, angle + sliceAngle));
        path.setAttribute("fill", COLORS[s % COLORS.length]);
        svg.appendChild(path);
      }
      angle += sliceAngle;
    }
    pieEl.innerHTML = "";
    pieEl.appendChild(svg);
  }

  function initAll() {
    var pies = document.querySelectorAll("[data-pie]");
    for (var i = 0; i < pies.length; i++) {
      var pieEl = pies[i];
      var id = pieEl.getAttribute("data-pie");
      if (!id) continue;

      var root = document.getElementById(id);
      if (!root) {
        var p = pieEl.parentElement;
        while (p && p.id !== id) p = p.parentElement;
        root = p || document;
      }
      var legendEl = root.querySelector('[data-legend="' + id + '"]') ||
                     document.querySelector('[data-legend="' + id + '"]');
      if (!legendEl) continue;

      renderPie(pieEl, legendEl);
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();